/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairOrderCancelRefund } from '../../models/finnair-order-cancel-refund';

export interface FetchOrderCancelRefund$Params {
  orderId: string;
  locale?: string;
  hash: string;
}

export function fetchOrderCancelRefund(http: HttpClient, rootUrl: string, params: FetchOrderCancelRefund$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairOrderCancelRefund>> {
  const rb = new DapiRequestBuilder(rootUrl, fetchOrderCancelRefund.PATH, 'get');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairOrderCancelRefund>;
    }),
    catchErrorAsJson()
  );
}

fetchOrderCancelRefund.PATH = '/api/v2/order/{orderId}/refund/informative';
